"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.theme = void 0;
const theme = {
  background: 'ui3',
  backgroundChecked: 'interactive.primary.default',
  backgroundCheckedDisabled: 'disabled.2',
  backgroundDisabled: 'disabled.1',
  size: 20,
  toggleBackground: 'background.default',
  toggleBoxShadow: [0, 0, 1, 1, 'ui4'],
  toggleSize: 14
};
exports.theme = theme;
//# sourceMappingURL=Switch.theme.js.map